import {setPosition} from "@/api/data";
import COVERAPP from "@/utils/COVERAPP";

export const RandomNumBoth = (Min, Max) => {
    let Range = Max - Min;
    let Rand = Math.random();
    let num = Min + Math.round(Rand * Range);
    return num;
};

export const shareTitle = () => {
    const random = RandomNumBoth(0, 2);
    let rankArray1 = ["这个小封机器人送给你体验一下，记得还我", "我发现了一个非常好玩的资讯机器人，一起来试试！", "这是我见过最牛的资讯机器人了，强烈安利给你！"];
    let rankArray2 = ["有了他，每天的热门事件再也不会错过！他还可以陪你聊天，玩游戏解闷", "根本停不下来，他真的太懂我了！看新闻、玩游戏、聊八卦，啥都不耽误~", "根本停不下来，他真的太懂我了！看新闻、玩游戏、聊八卦，啥都不耽误~"];
    return {title: rankArray1[1], desc: rankArray2[1]};
};

export const insertStr = (soure, start, newStr) => {
    return soure.slice(0, start) + newStr + soure.slice(start);
};

export const parseData = (list, string) => {
    let array = [];
    for (let i = 0; i < list.length; i++) {
        if (list[i].indexOf(string) !== -1) {
            let tag = list[i].indexOf(string);
            let tag1 = "<span style=\"color: #1890ff\">".length;
            let flag1 = insertStr(list[i], tag, "<span style=\"color: #1890ff\">");
            let flag2 = insertStr(flag1, tag + string.length + tag1, "</span>");
            array.push(flag2);
        } else {
            array.push(list[i]);
        }
    }
    return array;
};

export const getDevice = () => {
    //  0:微信  1:app  2:qq   100：游客
// 网页开启临时测试app
    let deviceFlag = 100;
    if (COVERAPP.Attribute.isWeixin()) {
        deviceFlag = 0;
    }
    if (COVERAPP.Attribute.isApp()) {
        deviceFlag = 1;
    }
    if (COVERAPP.Attribute.isQQ()) {
        deviceFlag = 2;
    }
    return deviceFlag;

};
//解决ios点击空白区域键盘收回问题
export const objBlurFun = (device, sDom, time = 100) => {  //sDom, input / textarea 都可以。
    if (device == "ios") {  // 如果是ios环境下
        let obj = document.querySelector(sDom);   // 这里如果传入的是2个以上 需要用querySelectorAll() 同时
        objBlur(obj, time);                  //  需要遍历调用函数
    }
};
export const objBlur = (sDom, time = 100) => {
    if (sDom) {
        sDom.addEventListener("focus", () => {
                document.addEventListener("touchend", e => {   // 这里的e非常重要，用来判断是否是点击了input表单
                    docTouchend(time, sDom, e);
                });
            },
            false
        );
    }
};
// 元素失去焦点隐藏iphone的软键盘
export const docTouchend = (time, sDom, e) => {
    if (e.target != sDom && e.target.className.indexOf("themeBig") < 0) {     // 如果点击的是 屏幕空白处的情况下
        setTimeout(() => {
            sDom.blur();      // 表单失去焦点  键盘就会自动收起

            window.scroll(0, 0);
            document.removeEventListener("touchend", docTouchend, false);   // 收起之后 移除监听器
        }, time);
    } else {
    }
};

/*获取地理位置*/

export const getLocationPoint = () => {
    const obj = {};
    return new Promise((resolve, reject) => {
        try {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    obj.latitude = position.coords.latitude;//获取纬度
                    obj.longitude = position.coords.longitude;//获取经度
                    resolve(obj);
                }, () => {
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            alert("定位失败,用户拒绝请求地理定位");
                            break;
                        case error.POSITION_UNAVAILABLE:
                            alert("定位失败,位置信息是不可用");
                            break;
                        case error.TIMEOUT:
                            alert("定位失败,请求获取用户位置超时");
                            break;
                        case error.UNKNOWN_ERROR:
                            alert("定位失败,定位系统失效");
                            break;
                    }
                }, {
                    enableHighAccuracy: true,
                    timeout: 1000,
                    maximumAge: 1000
                });
            } else {
                alert("不支持定位功能");
            }
        } catch (e) {
            reject(e);
        }

    });
};

export const getBaiduLocation = () => {
    // 百度地图API功能
  
    let geolocation = new BMap.Geolocation();
    geolocation.getCurrentPosition(function (r) {
      
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            setPosition({latitude: r.point.lat, longitude: r.point.lng});
        } else {
            setPosition({latitude: null, longitude: null});
            // switch( this.getStatus() )
            // {
            //     case 2:
            //         alert( '位置结果未知,获取位置失败');
            //         break;
            //     case 3:
            //         alert( '导航结果未知,获取位置失败');
            //         break;
            //     case 4:
            //         alert( '非法密钥,获取位置失败');
            //         break;
            //     case 5:
            //         alert( '对不起,非法请求位置,获取位置失败');
            //         break;
            //     case 6:
            //         alert( '对不起,当前没有权限,获取位置失败');
            //         break;
            //     case 7:
            //         alert( '对不起,服务不可用,获取位置失败');
            //         break;
            //     case 8:
            //         alert( '对不起,请求超时,获取位置失败');
            //         break;
            //
            // }
            // alert('获取地理位置信息失败');
        }
    }, {enableHighAccuracy: true});
};


/* 判断字符串中是否包含某字符串 */
export const matchRegExps = (path, str) => {
    const regStr = new RegExp(path);
    return regStr.test(str);
};
export const createArray = (n,type) => {

//type :1 火   2：星星
    if (checkRate(n) && n <= 5) {

        let array = new Array(n).fill({});
        array.map((it, ix) => {
            it.star = type===2?'tiny':"star";
        });

        return array;
    } else {

        let array = new Array(Math.floor(n)).fill({});
        array.map((it, ix) => {
            it.star = type===2?'tiny':"star";
        });
        array.push({star: type===2?'tinyic':"starci"});
        return array;
    }

};

export function checkRate(input) {
    let re = /^[1-9]+[0-9]*]*$/;   //判断字符串是否为数字     //判断正整数

    if (!re.test(input)) {
        return false;
    }
    return true;
}

export const writeText = (ctx, text, textStyle, width, left, top, lineHeight) => {
    ctx.font = `${textStyle.font} Helvetica, Tahoma, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei"`;
    ctx.textAlign = textStyle.align;
    ctx.textBaseline = textStyle.baseline;
    ctx.fillStyle = textStyle.color;
    let line = "";
    if (lineHeight) {
        for (let n = 0; n < text.length; n++) {
            let textLine = line + text[n];
            let metrics = ctx.measureText(textLine);
            let textWidth = metrics.width;
            if (textWidth > width && n > 0) {
                if ("，！。？；《".indexOf(text[n]) > -1) {
                    ctx.fillText(line.slice(0, n - 1), left, top);
                    line = `${text[n - 1]}${text[n]}`;
                } else {
                    ctx.fillText(line, left, top);
                    line = text[n];
                }
                top += lineHeight;
            } else {
                line = textLine;
            }
        }
    } else {
        line = text;
    }
    ctx.fillText(line, left, top);
    return ctx.measureText(line).width;
};


export function formatAudioTime(time) {
    // console.log(time)
    let minutes = Math.floor(time / 60)
    let seconds = Math.floor(time - minutes * 60)
    // console.log(minutes, seconds)
    return `${minutes > 9 ? minutes : `0${minutes}`}:${seconds > 9 ? seconds : `0${seconds}`}`
}

export function formatDate(date, formatter) {
    let dateTime = new Date(date)
    if (/(y+)/.test(formatter)) {
        formatter = formatter.replace(RegExp.$1, (dateTime.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
        'M+': dateTime.getMonth() + 1,
        'd+': dateTime.getDate(),
        'h+': dateTime.getHours(),
        'm+': dateTime.getMinutes(),
        's+': dateTime.getSeconds()
    }

    for (let k in o) {
        if (new RegExp(`(${k})`).test(formatter)) {
            let str = o[k] + ''
            formatter = formatter.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length))
        }
    }
    return formatter
}

export function formatMonthDay(time) {
    return formatDate(time, "M月d日");
}

export function defPreImage(url) {
    return new Promise((resolve, reject) => {
        let img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = url;
        img.onload = function () {
            resolve(img);
        };
    });
}
//弹出框
export function popConfirm(text, func1, func2) {
    let confirm = window.confirm(text);
    if (confirm==true){
        func1()
    }
    else{
        func2()
    }
}

export function audioDetailTemplate(list, name) {
    return [
        {
            "content": {
                "tips": `小封温馨提示：正在播放的是【${name}】，你还可以在下方自选频道哦`,
                "view": 100
            }
        },
        {
            "content": {
                "tips": "",
                "view": 28,
                "list": list
            }
        },
        {
            "content": {
                "tips": "",
                "view": 12,
                "list": [{
                    "color": "interest",
                    "name": "边听边玩其他的",
                    "id": "",
                    "value": "边听边玩其他的",
                    "radioType": 20
                }]
            }
        },
        {
            "content": {
                "tips": "",
                "view": 104,
                "list": {
                    "value": "audio"
                }
            }
        }
    ]
}

export function ximalayaDetailTemplate(list, name) {
    return [
        {
            "content": {
                "tips": `小封温馨提示：正在播放的是【${name}】，你还可以在下方自选频道哦`,
                "view": 100
            }
        },
        {
            "content": {
                "tips": "",
                "view": 31,
                "list": list
            }
        },
        {
            "content": {
                "tips": "",
                "view": 12,
                "list": [{
                    "color": "interest",
                    "name": "边听边玩其他的",
                    "id": "",
                    "value": "边听边玩其他的",
                    "radioType": 19
                }]
            }
        },
        {
            "content": {
                "tips": "",
                "view": 104,
                "list": {
                    "value": "audio"
                }
            }
        }
    ]
}
// 获取用户的语音设置权限
export function  getUserMedia(constrains,success,error) {

    if (navigator.mediaDevices.getUserMedia) {
      // 最新标准API
    //   console.log("最新标准API");
      navigator.mediaDevices.getUserMedia(constrains).then(stream => { success(stream); }).catch(err => { error(err); });
    } else if (navigator.webkitGetUserMedia) {
      // webkit内核浏览器
    //   console.log("webkit内核浏览器");
      navigator.webkitGetUserMedia(constrains).then(stream => { success(stream); }).catch(err => { error(err); });
    } else if (navigator.mozGetUserMedia) {
      // Firefox浏览器
    //   console.log("Firefox浏览器");
      navigator.mozGetUserMedia(constrains).then(stream => { success(stream); }).catch(err => { error(err); });
    } else if (navigator.getUserMedia) {
      // 旧版API
    //   console.log("旧版API  ");
      navigator.getUserMedia(constrains).then(stream => { success(stream); }).catch(err => { error(err); });
    }
  }
//   调用摄麦克风
export function getmicrophone(success,error){
    // console.log("进入获取麦克风权限1",navigator.mediaDevices)
   
      // 老的浏览器可能根本没有实现 mediaDevices，所以我们可以先设置一个空的对象
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
        // console.log("老的浏览器可能根本没有实现 mediaDevices");
      }
      
      // 一些浏览器部分支持 mediaDevices。我们不能直接给对象设置 getUserMedia
      // 因为这样可能会覆盖已有的属性。这里我们只会在没有getUserMedia属性的时候添加它。
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function(constraints) {
      
          // 首先，如果有getUserMedia的话，就获得它
          var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
      
          // 一些浏览器根本没实现它 - 那么就返回一个error到promise的reject来保持一个统一的接口
          if (!getUserMedia) {
            // console.log("一些浏览器根本没实现它");
            return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
          }
      
          // 否则，为老的navigator.getUserMedia方法包裹一个Promise
          return new Promise(function(resolve, reject) {
            // console.log("为老的navigator.getUserMedia方法包裹一个Promise");
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        }
      }

    getUserMedia(
      { audio: true },
      function() {
        console.log("已点击允许,开启成功");
        success()
      },
      function(data) {
        
          error(data.name)
        console.log("出错的是什么？", data,data.name);
      }
    ); 
}
